module.exports = __webpack_public_path__ + "media/images/confirm-email-bg-eb5353c32847b4a5d3bd54ec09c98862.svg";